var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[(_vm.showClassStartingBanner)?_c('class-starting-banner'):_vm._e(),_vm._v(" "),(_vm.showMissingFeedbackBanner)?_c('missing-feedback-banner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }